module.exports = __webpack_public_path__ + "static/media/research_01.84145c92.png";